/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "message": {
                    "nested": {
                      "Pagination": {
                        "fields": {
                          "cursor": {
                            "type": "uint32",
                            "id": 1,
                            "rule": "optional"
                          },
                          "maxResults": {
                            "type": "uint32",
                            "id": 2,
                            "rule": "optional",
                            "options": {
                              "default": 100
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.message?.nested?.Pagination) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Pagination @ squareup/devicesettings/profiles/v2/message/pagination.proto at 10:1
 */
export const Pagination = $root.lookupType('squareup.devicesettings.profiles.v2.message.Pagination');
fixType(Pagination);
Builder.createAndAttachToType(Pagination);